import React from 'react';
import PropTypes from 'prop-types';

import ReduxStoreTracker from './tracker-redux-store';

function mapStateToDL(state) {
  const {gsConfig, version} = state;
  const {shstoreId, shstoreDescription, defaultCurrency, defaultWebTLD, currentLocale, features} = gsConfig;

  return {
    shstoreId,
    shstoreDescription,
    defaultCurrency,
    defaultWebTLD,
    currentLocale,
    features,
    version,
  };
}

class SiteInfoTracker extends React.PureComponent {
  static contextTypes = {
    cookies: PropTypes.object,
  };
  constructor(props, ctx) {
    super(props, ctx);
    const {cookies} = ctx;
    this.visitorId = cookies && cookies.get && cookies.get('SH_VI');
    this.reducer = (state) => {
      return {
        shVI: this.visitorId,
        ...mapStateToDL(state),
      };
    };
  }
  render() {
    return <ReduxStoreTracker storeKey="siteInfo" reducer={this.reducer} />;
  }
}

export default SiteInfoTracker;
